import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { serverURL } from "../components/networking";
import korotuLogo from "../resources/KorotuLogo.png";

export default function ConfirmPage() {
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    return (
        <div className="login-page">
            <div className="login-left">
                <div className="login-brand">
                    <img src={korotuLogo} alt="Korotu logo" />
                </div>
            </div>

            <div className="login-right">
                <ConfirmRegisterForm
                    navigate={navigate}
                    setErrorMessage={setErrorMessage}
                    errorMessage={errorMessage}
                />
            </div>
        </div>
    );
}

function ConfirmRegisterForm({ navigate, setErrorMessage, errorMessage }) {
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [email, setEmail] = useState("");
    const location = useLocation();

    function confirmEmail(code, email, password, passwordVerify) {
        if (
            password === passwordVerify &&
            password !== "" &&
            code !== "" &&
            email !== ""
        ) {
            let csrf = document.cookie.replace(
                /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
                "$1",
            );
            setErrorMessage("");
            axios
                .post(
                    serverURL + "/api/user/confirm/",
                    { email: email, password: password, code: code },
                    {
                        withCredentials: true,
                        headers: {
                            "X-CSRFToken": csrf,
                        },
                    },
                )
                .then(function (response) {
                    console.log(response);
                    navigate("/");
                })
                .catch(function (error) {
                    console.log(error);
                    console.log(error.response);
                    setErrorMessage(error.response.data.message);
                });
        } else if (password !== passwordVerify) {
            setErrorMessage("Passwords don't match!");
        } else {
            setErrorMessage("No fields may be left blank!");
        }
    }

    return (
        <div className="login-card">
            <h2>Confirm Email</h2>
            <p className="login-helper">
                You should have recieved a code sent to the email you
                registered.
            </p>
            <div className="login-field">
                <label htmlFor="confirm-code">Code</label>
                <input
                    id="confirm-code"
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />
            </div>
            <div className="login-field">
                <label htmlFor="confirm-password">Password</label>
                <input
                    id="confirm-password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <div className="login-field">
                <label htmlFor="confirm-password-confirm">
                    Confirm Password
                </label>
                <input
                    id="confirm-password-confirm"
                    type="password"
                    value={password2}
                    onChange={(e) => setPassword2(e.target.value)}
                />
            </div>
            <button
                type="button"
                onClick={() => {
                    const email = location.state.email;
                    confirmEmail(code, email, password, password2);
                }}
            >
                Submit
            </button>
            <button
                type="button"
                className="login-secondary"
                onClick={() => {
                    setErrorMessage("");
                    navigate("/");
                }}
            >
                Return to Login
            </button>
            {errorMessage ? (
                <p className="error-message" role="alert">
                    {errorMessage}
                </p>
            ) : null}
        </div>
    );
}
